import { render, staticRenderFns } from "./reminder-info.vue?vue&type=template&id=7c05fd2f&scoped=true&"
import script from "./reminder-info.vue?vue&type=script&lang=js&"
export * from "./reminder-info.vue?vue&type=script&lang=js&"
import style0 from "./reminder-info.vue?vue&type=style&index=0&id=7c05fd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05fd2f",
  null
  
)

export default component.exports